import { ShoppingCart } from 'lucide-react';
import { data, dinheiro, nomeParceiro, textoLivre } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';

/** Lista de 30/10 (item 10): compras (número, descrição, fornecedor e nota fiscal, a busca da lista). Abre a ficha (`?compra=`). */
interface CompraBusca {
  id: string;
  numero: string;
  descricao: string;
  fornecedor_nome: string | null;
  competencia: string;
  total_centavos: number;
  moeda: string;
}

export const buscaCompras: FonteBuscaGlobal[] = [
  {
    chave: 'compras',
    permissao: 'compras.ver',
    pagina: 'compras.compras',
    grupo: 'buscaGlobal.compras',
    posicao: 85,
    icone: ShoppingCart,
    item: (c: CompraBusca) => ({
      id: c.id,
      rotulo: `${c.numero} · ${nomeParceiro(c.fornecedor_nome)}`,
      detalhe: [textoLivre(c.descricao, c.fornecedor_nome), data(c.competencia), dinheiro(c.total_centavos, c.moeda)].filter(Boolean).join(' · '),
      link: `${caminhoDaAba('compras', 'compras')}?compra=${c.id}`,
    }),
  },
];
